/**************************************************
 * Nombre:       Galleria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Foto from "../../Tarjetas/Tarjeta_Foto";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Galleria = () => {
    const {sCell, sTab} = useResponsive()
    const cData = useContext(contexApp)
    const [fotos, setFotos] = useState([])

    useEffect(() => {

        if (cData.fotos){
            setFotos(cData.fotos)
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: sCell ? 2 : sTab ? 3 : 5,
                            arrows: false,
                            pagination: false,
                            width: '100%',
                            drag: 'false',
                            interval: 8000,
                            noDrag: true,
                            type: 'loop',
                            gap: 20
                        }}
                    >

                        {fotos.map((it, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Tarjeta_Foto item={it}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Galleria

